import {useState, useEffect} from 'react';
import axios from 'axios';
import {FeaturedIcon} from '@burna/monster-design-system';
import {APIName} from 'config';
import {getFilesSizeString} from './utils';
import styles from './index.module.scss';


const boxes = [
  {
    getValue: data => data.uploadsSizeInBytes + data.downloadsSizeInBytes,
    caption: 'Traffic usage',
    color: 'purple',
    icon: 'repeat',
  },
  {
    getValue: data => data.uploadsSizeInBytes,
    caption: 'Drive usage',
    color: 'blue',
    icon: 'hard-drive',
  }
];


function Stats() {
  const [data, setData] = useState({});
  useEffect(() => {
    axios.get(`/api/${APIName}/stats`)
      .then(({data}) => {
        setData(data);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <section className={styles.stats}>
      <ul className={styles.list}>
        {boxes.map((box, i) => (
          <li key={i} className={styles.stat}>
            <div className={styles.statWrapper}>
              <FeaturedIcon className={styles.statIcon} theme="light-circle-outlined" type={box.color} icon={box.icon} shadow />
              <div className={styles.statText}>
                <span className={styles.statTitle}>{getFilesSizeString(box.getValue(data))}</span>
                <span className={styles.statSubtitle}>{box.caption}</span>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default Stats;
